import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthenticationService, IsLoggedInInjector } from '@next/core-lib/authentication';
import { EMPTY, filter, skipWhile, switchMap, take } from 'rxjs';

@Injectable()
export class ExternalLabResultsTokenInterceptor implements HttpInterceptor {
  private readonly isLoggedIn = inject(IsLoggedInInjector);
  private readonly authentication = inject(AuthenticationService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (!req.url.includes('/external/labresult-v2-service/') || req.headers.has('Authorization')) {
      return next.handle(req);
    }

    return this.isLoggedIn.pipe(
      skipWhile((isLoggedIn) => isLoggedIn === null),
      take(1),
      switchMap((isLoggedIn) =>
        isLoggedIn
          ? this.authentication.acquireToken().pipe(
              filter((accessToken): accessToken is string => typeof accessToken === 'string'),
              switchMap((accessToken) =>
                next.handle(
                  req.clone({
                    setHeaders: { Authorization: `Bearer ${accessToken}` },
                  }),
                ),
              ),
            )
          : EMPTY,
      ),
    );
  }
}
